import InitializeDatadog from './InitializeDatadog';

export default InitializeDatadog;
